import React, { type FC } from "react";
import { withPrefix } from "@tracking/tracking";
import {
  screenNames,
  useScreenState,
} from "clientState/AuthFlow/providers/ScreenProvider";
import { useTrackElement, useTranslation } from "@edreamsodigeo/frontend-core";
import {
  Body,
  Box,
  Checkbox,
  CheckboxField,
  CheckboxLabel,
} from "@edreamsodigeo/prisma-design-system";

import type { NewsletterStateProps } from "./contract";
import { useNewsletterOption } from "./useNewsletterOption";

const { AUTH_METHODS } = screenNames;

const NewsletterOption: FC<NewsletterStateProps> = ({
  shouldShow,
  trackingPrefix,
}) => {
  const { state } = useScreenState();
  const { handleChangeAcceptsNewsLetter } = useNewsletterOption();

  const CHECKBOX_ID = `${AUTH_METHODS}_${
    state.userData.acceptsNewsletter ? "uncheck" : "check"
  }:newsletter`;

  const clickTrackingRef = useTrackElement(
    ["click"],
    withPrefix(CHECKBOX_ID, trackingPrefix),
  );
  const { t } = useTranslation();

  if (!shouldShow) {
    return null;
  }

  return (
    <Box
      p="base"
      my="1x_small"
      width="100%"
      backgroundColor="blue.20"
      borderRadius="small"
    >
      <CheckboxField
        ref={clickTrackingRef}
        alignItems="center"
        justifyContent="center"
      >
        <Checkbox
          onChange={handleChangeAcceptsNewsLetter}
          checked={state.userData.acceptsNewsletter}
          sx={{ transform: "scale(0.66, 0.66)" }}
        />
        <CheckboxLabel>
          <Body type="xSmall" color="info.70" inline>
            {t("authentication.authMethods.newsletter.checkbox")}
          </Body>
        </CheckboxLabel>
      </CheckboxField>
    </Box>
  );
};

export default NewsletterOption;
